import { useNavigate, useParams } from 'react-router-dom';

const useIterationNavigate = () => {
  const { teamId, campaignId, iterationId } = useParams();
  const navigate = useNavigate();

  const getIterationBasePath = (): string => {
    let basePath = '';

    if (teamId) {
      basePath = `/${teamId}/campaign/${campaignId}/iteration/`;
    } else {
      basePath = '/campaign/iteration/';
    }

    if (iterationId) {
      return `${basePath}${iterationId}/`;
    }

    return basePath;
  };

  const getIterationPathFor = (path: string): string => {
    const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
    const basePath = getIterationBasePath();
    return `${basePath}${normalizedPath}`;
  };

  const navigateToIteration = (path: string): void => {
    const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
    const fullPath = getIterationPathFor(normalizedPath);
    navigate(fullPath);
  };

  return { getIterationBasePath, getIterationPathFor, navigateToIteration };
};

export default useIterationNavigate;
